import { Link } from "react-router-dom";
import { ArrowUpRight, Mail, MapPin, Globe } from "lucide-react";
import { openCookieSettings } from "../../lib/consent";

const MARKETS = ["USA", "United Kingdom", "Canada", "Australia", "New Zealand", "UAE", "Saudi Arabia", "Europe", "Southeast Asia"];

export default function Footer() {
  return (
    <footer className="bg-ink border-t border-white/10 text-slate-400" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 lg:py-24 grid grid-cols-1 md:grid-cols-12 gap-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-2 mb-6">
            <span className="h-8 w-8 rounded-lg bg-neon flex items-center justify-center font-display font-black text-ink text-sm">OX</span>
            <span className="font-display font-bold text-lg tracking-tight text-white">
              OrthoPlani<span className="text-neon">X</span>
            </span>
          </div>
          <p className="text-sm leading-relaxed max-w-sm">
            A professional extension of your clinical team. Accurate, efficient and clinically thoughtful digital clear-aligner treatment planning for dental professionals worldwide.
          </p>
          <p className="mt-6 font-display text-2xl font-bold text-white">
            You Treat. <span className="text-neon">We Plan.</span>
          </p>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-xs font-semibold uppercase tracking-[0.25em] text-white mb-5">Company</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/approach" className="hover:text-neon transition-colors">Our Approach</Link></li>
            <li><Link to="/services" className="hover:text-neon transition-colors">Services</Link></li>
            <li><Link to="/how-it-works" className="hover:text-neon transition-colors">How It Works</Link></li>
            <li><Link to="/case-library" className="hover:text-neon transition-colors">Case Library</Link></li>
            <li><Link to="/for-labs" className="hover:text-neon transition-colors">For Dental Labs</Link></li>
            <li><Link to="/enterprise" className="hover:text-neon transition-colors">Enterprise</Link></li>
            <li><Link to="/pricing" className="hover:text-neon transition-colors">Pricing</Link></li>
            <li><Link to="/faq" className="hover:text-neon transition-colors">FAQ</Link></li>
            <li><Link to="/security" className="hover:text-neon transition-colors">Security &amp; Privacy</Link></li>
          </ul>
        </div>

        <div className="md:col-span-2">
          <h4 className="text-xs font-semibold uppercase tracking-[0.25em] text-white mb-5">Portal</h4>
          <ul className="space-y-3 text-sm">
            <li><Link to="/login" className="hover:text-neon transition-colors">Client Login</Link></li>
            <li><Link to="/register" className="hover:text-neon transition-colors">Create Account</Link></li>
            <li><Link to="/portal" className="hover:text-neon transition-colors inline-flex items-center gap-1">Submit a Case <ArrowUpRight className="h-3 w-3" /></Link></li>
          </ul>
        </div>

        <div className="md:col-span-3">
          <h4 className="text-xs font-semibold uppercase tracking-[0.25em] text-white mb-5">Contact</h4>
          <ul className="space-y-3 text-sm">
            <li className="flex items-center gap-2"><Mail className="h-4 w-4 text-neon" /> hello@orthoplanix.com</li>
            <li className="flex items-center gap-2"><Globe className="h-4 w-4 text-neon" /> Serving 30+ countries</li>
            <li className="flex items-start gap-2"><MapPin className="h-4 w-4 text-neon mt-0.5" /> Global remote planning team</li>
          </ul>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-6 lg:px-10 py-6 space-y-4">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
            <p className="text-xs">© {new Date().getFullYear()} OrthoPlaniX Treatment Planning. B2B professional services for dental professionals only.</p>
            <nav className="flex flex-wrap gap-x-4 gap-y-2 text-xs" aria-label="Legal" data-testid="footer-legal-links">
              <Link to="/privacy" className="hover:text-neon transition-colors" data-testid="footer-privacy-link">Privacy Policy</Link>
              <Link to="/cookies" className="hover:text-neon transition-colors" data-testid="footer-cookies-link">Cookie Policy</Link>
              <Link to="/terms" className="hover:text-neon transition-colors" data-testid="footer-terms-link">Terms of Service</Link>
              <button type="button" onClick={openCookieSettings} className="hover:text-neon transition-colors" data-testid="footer-cookie-settings-btn">Cookie settings</button>
              <button type="button" onClick={openCookieSettings} className="hover:text-neon transition-colors" data-testid="footer-do-not-sell-btn">Do Not Sell or Share My Personal Information</button>
            </nav>
          </div>
          <div className="flex flex-wrap gap-x-3 gap-y-1 text-[11px] text-slate-500">
            {MARKETS.map((m) => <span key={m}>{m}</span>)}
          </div>
        </div>
      </div>
    </footer>
  );
}
